import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "d-flex flex-column flex-shrink-1 me-auto" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "d-flex align-center font-weight-bold" }
const _hoisted_5 = ["innerHTML"]

import { defineComponent } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailFile',
  props: {
  icon: {
    type: String,
    default: 'mdi-text-box-outline',
  },
  name: {
    type: String,
    required: true,
  },
  date: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    required: true,
  },
},
  setup(__props) {

defineComponent({ name: 'CwDetailFile' });



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_alert, {
    class: "pa-1",
    color: "info-opacity-2",
    value: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          icon: __props.icon,
          color: "info-darken-1",
          class: "cw-icon-log-file"
        }, null, 8, ["icon"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: "font-weight-bold",
            innerHTML: __props.name
          }, null, 8, _hoisted_3),
          _createVNode(_component_v_label, { text: __props.date }, null, 8, ["text"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", { innerHTML: __props.size }, null, 8, _hoisted_5)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})